import React from 'react';
import { AlertCircle, CheckCircle, Info, X, AlertTriangle } from 'lucide-react';
import { clsx } from 'clsx';

interface AlertProps {
  children: React.ReactNode;
  variant?: 'success' | 'error' | 'warning' | 'info';
  onClose?: () => void;
  className?: string;
}

export const Alert: React.FC<AlertProps> = ({
  children,
  variant = 'info',
  onClose,
  className,
}) => {
  const variants = {
    success:
      'bg-success-50 border-success-200 text-success-800 dark:bg-green-950/95 dark:border-green-600 dark:text-green-100',
    error:
      'bg-error-50 border-error-200 text-error-800 dark:bg-red-950/95 dark:border-red-600 dark:text-red-100',
    warning:
      'bg-warning-50 border-warning-200 text-warning-800 dark:bg-amber-950/95 dark:border-amber-600 dark:text-amber-100',
    info:
      'bg-primary-50 border-primary-200 text-primary-800 dark:bg-primary-900/95 dark:border-primary-600 dark:text-primary-100',
  };

  const icons = {
    success: CheckCircle,
    error: AlertCircle,
    warning: AlertTriangle,
    info: Info,
  };

  const Icon = icons[variant] ?? Info;

  return (
    <div
      className={clsx(
        'flex items-start gap-3 p-4 border rounded-lg',
        variants[variant],
        className
      )}
    >
      <Icon className="w-5 h-5 flex-shrink-0 mt-0.5" />
      <div className="flex-1">{children}</div>
      {onClose && (
        <button
          onClick={onClose}
          className="flex-shrink-0 text-current opacity-50 hover:opacity-100 transition-opacity"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};

